import React, { useState } from 'react';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import { Grid } from 'housecall-ui';
import ShippingAddressCard from './ShippingAddressCard';

const useStyles = makeStyles({
  alertBanner: {
    background: '#FFF8E1',
    color: '#000000',
  },
});

const PendingDowngradeMessage = () => {
  const { alertBanner } = useStyles();
  const [showAddressCard, setShowAddressCard] = useState(false);
  const showShippingAddressCard = () => {
    setShowAddressCard(true);
  }
  const handleCancel = () => {
   setShowAddressCard(false); 
  }
  return (
    <>
      <Grid item xs={12}><ShippingAddressCard open={showAddressCard} onCancel={handleCancel} dialogTitle="Request Return Label" /></Grid>
      <Alert
        severity="warning"
        className={alertBanner}
        action={
          <Button onClick={showShippingAddressCard}>
            Request return label
          </Button>
        }
      >
        Pending downgrade.
      </Alert>
    </>
  );
};

export default PendingDowngradeMessage;
